import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-detail-accessory-practice',
  templateUrl: './dialog-detail-accessory-practice.component.html',
})
export class DialogDetailAccessoryPracticeComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
